export enum ProductTemplateIdReferences {
  multiWorkspace = '4b55f7a6-4c4c-5900-b8c3-7bf5ec52e4a7',
}

export enum EducationResourcesIdReferences {
  checklists = '69edeb56-9cb1-5b0d-94af-b7845615a24c',
  eBooks = '00b33f53-c975-53dc-9eb8-079f70c1b194',
  events = '34c9601a-a5fd-5ffa-b6fe-5555fef357a1',
  fiveMinGuides = '34c9dbe3-6a57-5dde-937e-4f4aa23077c6',
  guides = '72e39bc3-e2e2-5c94-9d13-a45342bcb47c',
  reports = '6c0ff48a-4c28-5beb-9494-3faf21692ccc',
}

export enum EducationResourcesGuidesSlugReferences {
  objectivesOKRs = 'objectives-okrs',
  impactOfAi = 'impact-of-ai-on-pm',
  productStrategy = 'product-strategy',
  productOps = 'product-operations',
  featureFactory = 'feature-factory',
  internalPm = 'internal-pm',
  roadmaps = 'roadmaps',
  customerFeedback = 'customer-feedback',
  agile = 'agile',
  productManagement = 'product-management',
  productManagerJob = 'product-manager-job',
  prioritization = 'prioritization',
}

export enum EducationResourcesEbooksIdReferences {
  okrsHighPerformingTeams = 'af5ee44d-be5d-5321-8c06-b6fbb64dc6db',
  okrsRoundtable = '2ddeef63-9c0c-5708-99a7-6e94ae34971e',
  impactOfAi = '30c40f58-4ab7-524d-83e0-310225644350',
  productFirst = '2f42616d-7dd5-5388-862a-2ebe531afdb3',
  productStrategy = '63618dfd-5916-5bba-9df9-a53e5b2ae66d',
  productManagement = '0d29cc53-151a-5433-be18-1e18a968519f',
  productManagementOutcomeBased = '05204a16-38d4-567e-8b00-7578eeecc0f9',
  roadmaps = '09c7023f-72f1-56d1-a7c4-f78327fa6e92',
  customerFeedback = 'c90779a6-4eef-5bef-91e8-71dacad9539e',
  productOps = '549ac3af-41cc-5125-8d12-2f0ed4ac8d38',
  internalPm = '2ff071fa-6f27-55d2-bb29-c6e7f45d502f',
  featureFactory = '73e36a26-f0bc-50a5-a83c-7da70b45b688',
  featureFactoryRoundtable = 'a27dea86-1fae-59e0-951b-4a995ca24b0b',
  productManagerJob = '54d1d062-3a23-5255-a6e3-8add538b2064',
  agile = '8c0e33fd-2981-513f-a003-1ce25aa93353',
  prioritization = 'b3eff602-26f4-5892-acd4-a99af123820a',
}
